// extracted by mini-css-extract-plugin
export default {"container":"HeaderLogo_container__ROQMy","logo":"HeaderLogo_logo__7Dsd8"};